var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFileUnknown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_file_unknown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 325",
    opacity: 0.4,
    d: "M28 4L40 16H32C29.7909 16 28 14.2091 28 12V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8C8 5.79086 9.79086 4 12 4H28V12C28 14.2091 29.7909 16 32 16H40V40C40 42.2091 38.2091 44 36 44H12C9.79086 44 8 42.2091 8 40V8ZM26 30.8284V34H22V30C22 29.4696 22.2107 28.9609 22.5858 28.5858L25.2998 25.8717C25.7481 25.4234 26 24.8154 26 24.1814V24C26 22.8954 25.1046 22 24 22C22.8954 22 22 22.8954 22 24H18C18 20.6863 20.6863 18 24 18C27.3137 18 30 20.6863 30 24V24.1814C30 25.8763 29.3267 27.5017 28.1283 28.7002L26 30.8284ZM26.0001 38C26.0001 39.1046 25.1047 40 24.0001 40C22.8956 40 22.0001 39.1046 22.0001 38C22.0001 36.8955 22.8956 36 24.0001 36C25.1047 36 26.0001 36.8955 26.0001 38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFileUnknown);
export default __webpack_public_path__ + "static/media/ic_action_file_unknown.49a879ee5d8852380715a1924c933e57.svg";
export { ForwardRef as ReactComponent };